import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom'; // 如果是React Router
import Http from '@/api/axios';
function getPlatform() {
  const ua = navigator.userAgent;
  
  if (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
    return 'Mobile';
  } else if (/Win/i.test(ua)) {
    return 'Windows';
  } else if (/Mac/i.test(ua)) {
    // 排除iPad（新版iPadOS的userAgent可能包含Mac）
    if (/iPad/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
      return 'iPad';
    }
    return 'Mac';
  } else if (/Linux/i.test(ua)) {
    return 'Linux';
  } else {
    return 'Unknown';
  }
}
const useMobileStayTime = (options = {}) => {
  const {
    idleTimeout = 30000,   // 用户无操作30秒视为离开
    minStayTime = 1000,    // 最短有效停留时间(ms)
  } = options;

  const [stayStartTime, setStayStartTime] = useState(0);
  const [lastActiveTime, setLastActiveTime] = useState(0);
  const [sessionId, setSessionId] = useState('');
  const [deviceId, setDeviceId] = useState('');
  const pageUrlRef = useRef('');
  const [pathObj, setPathObj] = useState({});

  const location = useLocation(); // 获取路由信息
  const handlePageLeave = () => {
    console.log(location);
    if(!pathObj.pathname) return
    if( Date.now() - stayStartTime < 1000) return
    const logData = {
      userAgent: getPlatform(),
      eventType: 'PAGE_LEAVE',
      pageUrl: pathObj.pathname,
      pageTitle: document.title,
      query: pathObj.search,
      enterTime: stayStartTime,
      leaveTime: Date.now(),
      pageSessionId: sessionId
    };
    send(logData);
  };
  // 1. 生成设备标识（移动端关键）
  useEffect(() => {
    const generateDeviceId = () => {
      // 尝试从本地存储获取已有ID
      let id = localStorage.getItem('device_id');
      if (!id) {
        // 生成唯一设备标识（移动端可结合更多设备信息）
        id = 'mob_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        try {
          localStorage.setItem('device_id', id);
        } catch (e) {
          // 隐私模式或存储受限时使用session
          id = 'session_' + Date.now();
        }
      }
      setDeviceId(id);
    };

    generateDeviceId();
    setSessionId('sess_' + Date.now());
  }, []);

  // 2. 移动端触摸/滚动事件监听（替换鼠标事件）
  useEffect(() => {
    const updateActivity = () => {
      setLastActiveTime(Date.now());
    };

    // 移动端主要交互事件
    const events = ['touchstart', 'touchend', 'touchmove', 'scroll', 'click'];
    
    events.forEach(event => {
      document.addEventListener(event, updateActivity, { passive: true });
    });

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, updateActivity);
      });
    };
  }, []);

  // 3. 移动端页面可见性及状态变化
  useEffect(() => {
    // 记录页面URL（包含查询参数）
    pageUrlRef.current = window.location.href;

    const handleVisibilityChange = () => {
      console.log(222);
      if (document.visibilityState === 'visible') {
        // 页面重新可见
        setStayStartTime(Date.now());
      } else if (document.visibilityState === 'hidden') {
        // 页面隐藏（切换App、锁屏等）
        handlePageLeave();
      }
    };

    // 移动端特殊事件：页面进入后台、锁屏等
    const handlePageShow = () => {
      setStayStartTime(Date.now());
    };

    const handlePageHide = () => {
      handlePageLeave();
    };

    // 监听页面生命周期
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('pageshow', handlePageShow);
    window.addEventListener('pagehide', handlePageHide);

    // 开始记录停留时间
    setStayStartTime(Date.now());
    setLastActiveTime(Date.now());

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pageshow', handlePageShow);
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, []);//lastActiveTime

  // 4. 处理页面离开（路由变化或页面卸载）
  useEffect(() => {
    // 处理路由变化（SPA应用）
    setPathObj(location)
    handlePageLeave();
    
    return () => {
      // handlePageLeave();
    };
  }, [location.pathname, deviceId, sessionId]);

  const send = async (data) => {
    try {
      // 使用 navigator.sendBeacon 确保页面关闭时也能发送
      const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
      
      if (navigator.sendBeacon) {
        navigator.sendBeacon(process.env.REACT_APP_API+'/api/log/save', blob);
      } else {
        // 兼容方案
        await fetch(process.env.REACT_APP_API+'/api/log/save', {
          method: 'POST',
          body: data,
          keepalive: true
        });
        setStayStartTime(Date.now());
      }
    } catch (e) {
      console.error('Tracking error:', e);
      setStayStartTime(Date.now());
    }
  };
  return { deviceId, sessionId };
};

export default useMobileStayTime;